import { useState, useEffect } from 'react'
import { authService, AuthState, User } from '../services/auth'

export const useAuth = () => {
  const [authState, setAuthState] = useState<AuthState>({
    user: null,
    isAuthenticated: false,
    isLoading: false,
    error: null
  })

  useEffect(() => {
    // Subscribe to auth state changes
    const unsubscribe = authService.subscribe(setAuthState)
    
    return unsubscribe
  }, [])

  const signInWithGoogle = async (): Promise<User> => {
    return authService.signInWithGoogle()
  }

  const signOut = async (): Promise<void> => {
    return authService.signOut()
  }

  const initializeAuth = async (): Promise<void> => {
    try {
      await authService.initializeGoogleAuth()
    } catch (error) {
      console.error('Failed to initialize auth:', error)
    }
  }

  return {
    ...authState,
    signInWithGoogle,
    signOut,
    initializeAuth
  }
} 